export type SupportConversation = {
  id: string;
  subject: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  lastMessage: {
    content: string;
    isAdmin: boolean;
    createdAt: string;
    id: string;
  };
  unreadCount: number;
};
export type SupportMessageType = {
  id: string;
  senderId: string;
  isAdmin: boolean;
  content: string;
  createdAt: string;
  threadId: string;
  senderName?: string;
};

export type SupportMessagesResponse = {
  result: SupportMessageType[];
  hasMore: boolean;
  nextCursor: string;
};

export type CreateNewSupportChatResponse = {
  id: string;
  organisation_id: string;
  subject: string;
  status: string;
  created_by: string;
  created_at: string;
  updated_at: string;
  closed_at: string | null;
  closed_by: string | null;
  messages: SupportMessageType[];
};

export interface SupportChatSubject {
  id: string;
  name: string;
  /**
   * `null` means the subject routes to no specific group — the design's
   * "All" target; any agent can claim threads tagged with it.
   */
  assignedGroupId: string | null;
  assignedGroup: SubjectGroupSummary | null;
  relatesToAccount: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SubjectGroupSummary {
  id: string;
  name: string;
}

export enum ThreadStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}
